module.exports = __webpack_public_path__ + "img/rank_1_avatar.702829e2.jpg";